// extracted by mini-css-extract-plugin
export default {"overlay":"GD-z","bodyOpen":"HD-z","content":"ID-z","header":"JD-z","close":"KD-z","closeNoHeading":"LD-z"};